import React from 'react'
import { GreenTick } from '../../../../assests/ExportImageIcon'
import './busSeatSelection.css'
import './busCancel.css'

// Static placeholder — no bus API exists yet, so the cancellation notes and
// refund-rules table below are hardcoded to match the reference design (no
// state, no click behaviour). Content only (no tab bar) — rendered by
// SeatBookingPanel.jsx alongside the CANCELLATION tab.
const CANCEL_NOTES = [
    'Book with ₹0 Payment',
    'High demand for your selected dates, pay before 31 Mar, 11:59 PM IST to avoid auto-cancellation',
]

const REFUND_RULES = [
    { key: 'now', date: 'Now 03 Jun, 01:59 PM', percent: '100%', active: true },
    { key: 'later', date: '03 Jun, 02:00 PM - 06 Jun, 02:00 PM', percent: '0%', active: false },
]

const BusCancel = () => {
    return (
        <div className='seatSelectPanel'>
            <div className='seatSelectPanel__title'>Cancellation</div>

            <div className='busCancelPanel__body'>
                <div className='busCancelPanel__notes'>
                    {CANCEL_NOTES.map((note, index) => (
                        <div className='bookingBaggageItem' key={index}>
                            <img src={GreenTick} alt="" />
                            <span>{note}</span>
                        </div>
                    ))}
                </div>

                <div className='busCancelPanel__policyTitle'>
                    Cancellation Policy <span>(Refund Rules)</span>
                </div>

                <div>
                    {REFUND_RULES.map((rule) => (
                        <div className={`cancelPolicyRow ${rule.active ? 'cancelPolicyRow--active' : 'cancelPolicyRow--default'}`} key={rule.key}>
                            <span>{rule.date}</span>
                            <span>{rule.percent}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default BusCancel
